/**
 * Meta (Facebook) Pixel utility.
 * Loads the official fbevents.js snippet, initializes the pixel,
 * and exposes a tiny wrapper for tracking events.
 *
 * All calls are wrapped in try/catch so any failure here can NEVER
 * take down the host page.
 */

const PIXEL_ID = '2749178845442520'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

function loadPixelScript() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.fbq) return

  const w = window as any
  const d = document

  const fbq: any = function () {
    fbq.callMethod
      ? fbq.callMethod.apply(fbq, arguments as any)
      : fbq.queue.push(arguments)
  }
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  w.fbq = fbq
  if (!w._fbq) w._fbq = fbq

  const script = d.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = d.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    d.head.appendChild(script)
  }
}

export function initMetaPixel() {
  try {
    if (initialized) return
    if (typeof window === 'undefined') return
    loadPixelScript()
    if (window.fbq) {
      window.fbq('init', PIXEL_ID)
      initialized = true
    }
  } catch (err) {
    // Silent: never let analytics break the page.
    // eslint-disable-next-line no-console
    console.warn('Meta Pixel init failed', err)
  }
}

export function trackPageView() {
  try {
    if (typeof window === 'undefined') return
    if (!window.fbq) return
    window.fbq('track', 'PageView')
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Meta Pixel PageView failed', err)
  }
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  try {
    if (typeof window === 'undefined') return
    if (!window.fbq) return
    if (params) {
      window.fbq('track', eventName, params)
    } else {
      window.fbq('track', eventName)
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(`Meta Pixel ${eventName} failed`, err)
  }
}
